<template>
    <div style="display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
        <div>
            <div>
                <ProfileImage :imagePath="memberInfo.image_path" style="width: 77px;"></ProfileImage>
            </div>
            <div style="font-size: 12px; font-weight: 700; line-height: 21px; margin-top: 6px;">{{ memberInfo.nic_name === "" || memberInfo.nic_name === null ? memberInfo.name : memberInfo.nic_name }} <span style="font-size: 11px; font-weight: 900; color: var(--color-main);">{{ memberInfo.position }}</span></div>
            <div class="ellipsis" style="font-weight: 500; font-size: 11px; line-height: 21px; color: #999999; max-width: 129px;">{{ memberInfo.place_name }}</div>
        </div>
        <div style="display: flex; margin-top: 6px; gap: 9px; ">
            <div @click.stop="() => {}" @touchstart="touchStart(memberInfo)" @touchend="touchEnd(memberInfo)" ref="ballWrapper" style=" flex: 1; transition: all 0.3s; display: flex; position: relative; justify-content: center; align-items: center; gap: 4px; height: 28px; border-radius: 10px; background-color: var(--color-main);">
                <img ref="shoot" style="width: 42px; right: 8px; z-index: 1; opacity: 0; position: absolute;" :src="require('@/assets/img/shoot_red.png')" alt="">
                <img ref="soccerBall" style="width: 16px; position: relative; z-index: 2; left: 0;" :src="require('@/assets/img/soccer_ball2.png')" alt="">
            </div>
            <div @click.stop="sendDirectMessage(memberInfo)" style="border-radius: 10px; flex: 1; background-color: #210f03; height: 28px; display: flex; gap: 4px; justify-content: center;  align-items: center;">
                <img style="width: 12px" :src="require('@/assets/img/dm_main_color.png')" alt="">
                <!-- <div style="color: var(--color-main); font-size: 12px; font-weight: 700;">메시지</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { JOIN_CHAT_TYPE } from '@/Constants'

export default {
    name: "RecommendUser",
    components: {ProfileImage},
    props: {
        memberInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            isFriend: false
        }
    },
    created() {
        this.isShooting = this.memberInfo.is_liked
        if (this.isShooting) {
            this.$nextTick(() => {
                if (this.$refs.soccerBall) {
                    this.$refs.soccerBall.style.transition = 'all 0.3s'
                    this.$refs.soccerBall.style.transform = 'rotate(0)'
                    this.$refs.soccerBall.style.left = '13px'
                }
                if (this.$refs.shoot) {
                    this.$refs.shoot.style.opacity = '1'
                    this.$refs.shoot.style.transition = 'all 0.3s'
                }
                if (this.$refs.ballWrapper) {
                    this.$refs.ballWrapper.style.backgroundColor = 'var(--color-main)'
                }
            })
        }
    },
    methods: {
        async sendDirectMessage(memberInfo) {
            const isCoach = memberInfo.is_temp_coach == 1 ? true : false
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (!isCoach && this.$GlobalStore.loginInfo().is_temp_coach == 0) {
                this.showPersonalChat(memberInfo)
                return
            }
            this.$Util.showDirectMessageSenderForm({ memberInfo: memberInfo, isDirectUser: true });
        },
        async showPersonalChat(memberInfo) {
            await this.$Axios.showPersonalChat(memberInfo.idx, 0, JOIN_CHAT_TYPE.SINGLE);
        },
        touchStart() {
            if (!this.$GlobalStore.isLogin()) {
                return
            }
            if (!this.isShooting) {
                this.$refs.soccerBall.style.transform = 'rotate(-180deg)'
                this.$refs.soccerBall.style.transition = 'all 0.3s'
                this.$refs.soccerBall.style.left = '0px'
                this.$refs.ballWrapper.style.backgroundColor = '#da5800'
            }
        },
        touchEnd(memberInfo) {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            if (this.isShooting) {
                if (this.$refs.soccerBall) {
                    this.$refs.soccerBall.transition = ''
                    this.$refs.soccerBall.style.left = ''
                    this.$refs.soccerBall.style.transform = 'rotate(0)'
                }

                if (this.$refs.shoot) {
                    this.$refs.shoot.style.opacity = '0'
                }
            } else {
                if (this.$refs.soccerBall) {
                    this.$refs.soccerBall.style.transition = 'all 0.3s'
                    this.$refs.soccerBall.style.transform = 'rotate(0)'
                    this.$refs.soccerBall.style.left = '13px'
                }

                if (this.$refs.shoot) {
                    this.$refs.shoot.style.opacity = '1'
                    this.$refs.shoot.style.transition = 'all 0.3s'
                }

                if (this.$refs.ballWrapper) {
                    this.$refs.ballWrapper.style.backgroundColor = 'var(--color-main)'
                }
            }
            if (this.isShooting) {
                this.unlikeProfile(memberInfo)
            } else {
                this.saveFavoriteProfile(memberInfo)
            }
            this.isShooting = !this.isShooting
        },
        async unlikeProfile(memberInfo) {
            const formData = new FormData()
            formData.append('target_idx', memberInfo.idx)

            await this.$Axios.post('/api/like/member/delete', formData)
        },
        async saveFavoriteProfile(memberInfo) {
            const formData = new FormData()
            formData.append('target_idx', memberInfo.idx)

            const res = await this.$Axios.post('/api/like/member/save', formData)
            const isFriend = res.data.is_friend

            if (isFriend) {
                this.isFriend = true
                // setTimeout(() => {
                //     this.toggleShape()
                // }, 1000)
            }
        },
    },
}
</script>